import BgImage from 'assets/images/bg_image.png'
import styled from "styled-components/macro";

import { BREAKPOINTS } from "../index";

const RoseWrapper = styled.img`
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
  @media (max-width: ${BREAKPOINTS.md}px) {
      top: 40px;
    left: -220px;
      width: 800px;
  }
`

const EllipseHeader = styled.div`
  position: fixed;
  top: -45%;
  z-index: -1;
  left: calc(50% - 291px);
  width: 582px;
  height: 368px;
  background: rgba(180, 235, 86, 0.14);
  filter: blur(200px);
`

export const BackgroundWrapper = () => (
  <>
    <RoseWrapper src={BgImage} alt="background image" />
    <EllipseHeader />
  </>
)
